import { getScreens } from './getScreens';
import { getScreensFilterOptions } from './getScreensFilterOptions/getScreensFilterOptions';
import { getProxyComponents } from './getProxyComponents';
import { getScreenComponent } from './getScreenComponent';

export const screensService = {
  get: getScreens,
  getFilterOptions: getScreensFilterOptions,
  getProxyComponents: getProxyComponents,
  getComponent: getScreenComponent,
};
